import { ModelInstance, BaseModel, ToFrontHook, ToBackHook } from './util';
import { GameStatisticBase } from './game-statistic-base';

@ModelInstance({
  mappingFields: {
    game_user_id: 'gameUserId',
    serve_hits: 'serveHits',
    serve_faults: 'serveFaults',
    serve_aces: 'serveAces',
    good_serves: 'goodServes',
    stuff_blocks: 'stuffBlocks',
    block_faults: 'blockFaults',
    block_rebounds: 'blockRebounds',
    attack_spikes: 'attackSpikes',
    attack_faults: 'attackFaults',
    attack_shots: 'attackShots',
    receives: 'receives',
    receive_faults: 'receiveFaults',
    excellent_receives: 'excellentReceives',
    serve_receives: 'serveReceives',
    serve_receive_faults: 'serveReceiveFaults',
    excellent_serve_receives: 'excellentServeReceives',
    points: 'points',
    faults: 'faults',
    yellow_cards: 'yellowCards',
  }
})
export class VolleyballGameStatistic extends BaseModel implements GameStatisticBase {
  gameUserId: number;
  serveHits: number;
  serveFaults: number;
  serveAces: number;
  goodServes: number;
  stuffBlocks: number;
  blockFaults: number;
  blockRebounds: number;
  attackSpikes: number;
  attackFaults: number;
  attackShots: number;
  receives: number;
  receiveFaults: number;
  excellentReceives: number;
  serveReceives: number;
  serveReceiveFaults: number;
  excellentServeReceives: number;
  points: number;
  faults: number;
  yellowCards: number;

  get id(): number {
    return this.gameUserId;
  }

  get attacks(): number {
    return Math.floor(10 * (this.attackSpikes + this.attackShots)) / 10;
  }

  get blocks(): number {
    return Math.floor(10 * (this.stuffBlocks + this.blockRebounds)) / 10;
  }

  get totalReceives(): number {
    return Math.floor(10 * (this.receives + this.excellentReceives + this.receiveFaults)) / 10;
  }

  get totalServeReceives(): number {
    return Math.floor(10 * (this.serveReceives + this.excellentServeReceives + this.serveReceiveFaults)) / 10;
  }

  get totalServes(): number {
    return Math.floor(10 * (this.serveAces + this.serveHits + this.serveFaults + this.goodServes)) / 10;
  }

  get totalAttacks(): number {
    return Math.floor(10 * (this.attackSpikes + this.attackShots + this.attackFaults)) / 10;
  }

  get totalBlocks(): number {
    return Math.floor(10 * (this.stuffBlocks + this.blockRebounds + this.blockFaults)) / 10;
  }

  @ToFrontHook
  static toFront(data: any): any {}

  @ToBackHook
  static toBack(data: any): any {}
}
